import ProjectAPIError from "@/api/error/ProjectAPIError";

export default class ProjectAPIBadRequestError extends ProjectAPIError {
  get httpErrorMessage() {
    return "잘못된 요청입니다";
  }
}
